var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.072 11.714 3.705 6.57c-.262-.354-.284-.727 0-1.143L8.073.286A.8.8 0 0 1 9.227.21c.326.306.367.887.065 1.219l-4.033 4.57 4.033 4.572c.302.332.269.914-.057 1.22s-.882.274-1.163-.077"
})));
export default SvgChevronLeft;